import { baseResponseSchema } from 'services/api/api.types';
import { z } from 'zod/v4';

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/

const automaticWithdrawalResponseObjectSchema = z.object({
  accountCode: z.string(),
  amount: z.number(),
  validityTimestamp: z.number(),
  endTimestamp: z.number().optional(),
});

const automaticWithdrawalLimitResponseSchema = baseResponseSchema.extend({
  responseObject: automaticWithdrawalResponseObjectSchema,
});

type AutomaticWithdrawalLimitIResponse = z.infer<
  typeof automaticWithdrawalLimitResponseSchema
>;

export { automaticWithdrawalLimitResponseSchema };
export type { AutomaticWithdrawalLimitIResponse };
